import { render, staticRenderFns } from "./automation-container.vue?vue&type=template&id=47d7d230"
import script from "./automation-container.vue?vue&type=script&lang=js"
export * from "./automation-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports